import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { actionCreators } from "../redux/checkInSaga";

export function UpdateBtns({ reset }) {
  const dispatch = useDispatch();

  const filtersDirty = useSelector((state) => state.checkIns.filtersDirty);

  return (
    filtersDirty && (
      <div className="action-buttons">
        <button className="submit" onClick={() => dispatch(actionCreators.updateData())}>
          Update
        </button>
        <button className="submit reset" onClick={reset}>
          Reset
        </button>
      </div>
    )
  );
}
